<div
    (click)="goToPerformanceAnomaly()"
    [nTooltip]="str.anomalyIconTip"
    class="alarm-number badge-wrap anomaly-panel"
    id="anomaly-panel-icon">
    <svg class="icon header-icon">
        <use [attr.xlink:href]="isSimpleMode ? '#app-icon-header-anomaly-simple' : '#app-icon-header-anomaly'"></use>
    </svg>
    <app-badge-num [total]="total"></app-badge-num>
</div>
